

import { GAME_PENG, GAME_DNF } from '@tencent/pmd-tools/lib/game';
import { getConfig } from '@tencent/pmd-config';

const formatGoodsStatusText = function () {
  const gid = getConfig('game.gid');
  switch (gid) {
    case GAME_PENG:
    case GAME_DNF:
      return '立即使用';
    default:
      return '立即兑换';
  }
};
const formatUsedGoodsStatusText = function () {
  const gid = getConfig('game.gid');
  switch (gid) {
    case GAME_PENG:
      return '已使用';
    default:
      return '立即查看';
  }
};
export { formatGoodsStatusText, formatUsedGoodsStatusText };
